export const checkUser = async () => {
    return await fetch(`${process.env.REACT_APP_API_URL}/api/authenticate-user`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    }).then(async res => await res.json()).catch(error => {
        console.error(error);
        return false;
    });
};

export const loginUser = async (email, password) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const register = async (key, password) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ key, password }),
    });

    const data = await response.json();

    return data;
};

export const sendPasswordResetEmail = async (email) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-password-reset-email`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
    });

    const data = await response.json();

    return data;
};

export const resetPassword = async (token, newPassword) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/reset-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, newPassword }),
    });

    const data = await response.json();

    return data;
};

export const getUsers = async (page) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${page}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getSingleHistory = async (sessionId) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/history/${sessionId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};
export const addUser = async (name, email, role) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add-user`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name,
            email,
            role,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getHistory = async (page) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-history/${page}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getStatistics = async (filter) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/statistics/${filter}/${new Date().getTimezoneOffset() / -60}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getFeedback = async (page, filter) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-feedback/${page}/${filter}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getBotInformation = async (page) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/${page}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getSingleFeedback = async (Id) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/feedback/${Id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getHelpRequests = async (page, filter) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-help-requests/${page}/${filter}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getSingleHelpRequest = async (Id) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/help-requests/${Id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const changeHelpRequestStatus = async (id, change) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/help-requests/${change}/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getHelpRequestsCount = async (page, filter) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/all-help-requests-count`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const logoutUser = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getUser = async id => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const changePassword = async (id, oldPassword, newPassword) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/${id}/change-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            oldPassword,
            newPassword
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const deleteUser = async id => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/${id}/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const changeTheme = async (id, theme) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/change-theme`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            id,
            theme
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const addBotInfo = async content => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            content,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const editBotInfo = async ({ id, content, type }) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/edit/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            content,
            type,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const deleteBotInfo = async infoId => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/delete/${infoId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const uploadFile = async (files, pdfURLs, updateProgress, onFail) => {
    const formData = new FormData();

    let fileProgress = files.length + pdfURLs.length;

    pdfURLs = pdfURLs.filter(item => item.file.path);

    formData.append('capability', 'upload_document');
    formData.append('filesData', JSON.stringify([...files, ...pdfURLs]));

    for (let i = 0; i < files.length; i++) {
        try {
            formData.append('files', files[i].file, files[i].file.name);
            updateProgress(50 / fileProgress);
        } catch (error) {
            onFail(true);
            updateProgress(100);
            throw new Error(error);
        }

        fileProgress--;
    }

    for (let i = 0; i < pdfURLs.length; i++) {
        try {
            const response = await fetch(pdfURLs[i].source_url);
            const blob = await response.blob();
            const urlParts = pdfURLs[i].source_url.split('/');
            const filename = urlParts[urlParts.length - 1];
            const file = new File([blob], filename, { type: blob.type, lastModified: blob.lastModified });
            formData.append('files', file, filename);
            updateProgress(50 / fileProgress);
        } catch (error) {
            onFail(true);
            updateProgress(100);
            throw new Error(error);
        }

        fileProgress--;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/upload-files`, {
        method: 'POST',
        body: formData,
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const registerFile = async (filesData, updateProgress, onFail) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register-files`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                filesData
            }),
            credentials: "include",
        });

        const data = await response.json();

        updateProgress(100);

        return data;
    } catch (error) {
        onFail(true);
        updateProgress(100);
        throw new Error(error);
    }
};

export const getDocuments = async page => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${page}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const deleteDocument = async fileId => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${fileId}/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const updateDocument = async (file_id, title, source_url) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/documents/${file_id}/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            title,
            source_url,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const updateBotSettings = async (settings) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/bot-settings`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            settings,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getBotSettings = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/bot-settings`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    const data = await response.json();

    return data;
};


export const getSearchResults = async (search, limit, page) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            search,
            limit: limit || undefined,
            page: page || undefined,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const saveNewFunFacts = async funFacts => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/new`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            funFacts
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const getFunFacts = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const updateFunFact = async funFact => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/edit/${funFact.id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            funFact
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const deleteFunFact = async id => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/fun-facts/delete/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const approveBotInfo = async (id, content) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inform-the-bot/approve/${id}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            content,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const findBestMatchSearchResult = async (query, results) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/search/rerank`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            query,
            results,
        }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};

export const verifyCode = async (email, code) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-email-code`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, code }),
        credentials: "include",
    });

    const data = await response.json();

    return data;
};